export default __webpack_public_path__ + "static/media/approved-icon.b2227f93.svg";